import styled from 'styled-components';

import { flexAsColumn } from '@components/Styled/mixins';
import { Text } from '@components';

const UnlockLayout = styled.section`
  ${flexAsColumn(2)}

  align-items: stretch;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(2)};
  text-align: center;
  margin-top: ${({ theme }) => theme.spacing(2)};

  > * {
    width: auto;
  }

  > h2 {
    margin: 0;
  }

  > div {
    ${flexAsColumn(2)}
    align-items: center;
  }

  > form {
    ${flexAsColumn(2)}
    align-items: center;

    > * {
      width: auto;
    }

    > div {
      ${flexAsColumn(1)}
`;

const ButtonGroup = styled.section`
  ${flexAsColumn(4)}

  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 100%;
`;

const VPNErrorMessage = styled(Text)`
  color: ${({ theme }) => theme.palette.danger.main};
`;

export { ButtonGroup, UnlockLayout, VPNErrorMessage };
